import {
  language_item,
  logout_item,
  profile_item,
  support_item,
} from '../../../../../components/layout/ProfileDropdown';

export default {
  items: {
    [profile_item]: 'Profil',
    [language_item]: 'Changer de langue',
    [support_item]: 'Assistance',
    [logout_item]: 'Déconnexion',
  },
};
